<template>
    <div id="main" style="width: 100%;height: 100%;">
        <div class="wrapper wrapper-content" v-if="spvShow==true" v-show="show">
            <div style="margin-bottom: 20px;">
                <!--待办事项-->
                <div class="container-lf">
                    <div class="container_title">待办事项</div>
                    <ul class='backlog' id="backlog">
                        <!--<li funcid="11058" parentfuncid="10009" moduleid="10072" onclick="goBacklog(11058,10072,10009)">
                            <div class="backlog_title"><span class="lf">1.添加出勤记录</span></div>
                            <i class="backlog_mian">您尚未添加任何儿童出勤记录，赶紧去添加吧！</i>
                        </li>-->
                        <img src="../../assets/img/noneWait.png" style="margin: 73px auto 20px;width: 144px;height: 134px;display: block;">
                        <span style="margin:0 auto;display:block;font-size:14px;width:84px;color:#ccc;">暂无待办事项</span>
                    </ul>
                </div>
                <!--督导系统评分-->
                <div id="spvLoad" class="container_supervisor" style="display:block">
                    <div class="container_title">
                        督导系统
                        <span id="scale_marks" class="standardShow" @click="standardShow" onmouseout="javascript:this.style.backgroundColor='#63a0ef'" onmouseover="javascript:this.style.backgroundColor='#A7C8F5'">督导标准</span>
                    </div>
                    <div id="spvPre" style="width: 166px;height: 166px;margin: 20px auto;"></div>
                    <div style="margin:10px auto;width: 80%;height: 30px;" v-show="legendShow">
                        <div class="gradeCard" v-bind:style="zeroWidth">
                            <el-tooltip class="item" effect="dark" :content="'零分：'+data.zeroNum+'所'" placement="top-start">
                                <span class="zeroColor cardBar"></span>
                            </el-tooltip>
                        </div>
                        <div class="gradeCard" v-bind:style="badWidth">
                            <el-tooltip class="item" effect="dark" :content="'差：'+data.badNum+'所'" placement="top-start">
                                <span class="badColor cardBar"></span>
                            </el-tooltip>
                        </div>
                        <div class="gradeCard" v-bind:style="midWidth">
                            <el-tooltip class="item" effect="dark" :content="'中：'+data.midNum+'所'" placement="top-start">
                                <span class="midColor cardBar"></span>
                            </el-tooltip>
                        </div>
                        <div class="gradeCard" v-bind:style="goodWidth">
                            <el-tooltip class="item" effect="dark" :content="'好：'+data.goodNum+'所'" placement="top-start">
                                <span class="cardBar"></span>
                            </el-tooltip>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div class="legend" v-show="legendShow">
                        <span class="rg">
                            <i class="cardBar"></i>
                            <i>好</i>
                        </span>
                        <span class="rg">
                            <i class="midColor cardBar"></i>
                            <i>中</i>
                        </span>
                        <span class="rg">
                            <i class="badColor cardBar"></i>
                            <i>差</i>
                        </span>
                        <span class="rg">
                            <i class="zeroColor cardBar"></i>
                            <i>零分</i>
                        </span>
                        <div class="clear"></div>
                    </div>
                    <div class="legend" v-show="!legendShow" style="margin-top: 30px;text-align: center;">
                        <span class="gradeCard" style="background: #eee;height: 20px;display: inline-block;width: 100%;margin-bottom: 10px;"></span>
                        <span>暂无得分</span>
                    </div>
                    <div>
                        <span id="scoreShow" class="rg scoreShow" @click='scoreDetails("")'>得分详情&nbsp;&nbsp;&gt;</span>
                        <div class="clear"></div>
                    </div>
                    <div class="clear"></div>
                </div>
                <div class="clear"></div>
            </div>
            <div class="container-oftenUse">督导概况</div>
            <ul class="container_survey" id="survey">
                <li v-for="(item,i) in categoryList" @click="scoreDetails(item.id)">
                    <diet-pie :mapID="'dietPie'+i" :totalScore="item.totalScore" :avgScore="data.avgScore" :categoryId="item.id" :scorePolicyAreaId="data.scorePolicyAreaId" :scoreMonth="data.scoreMonth" :Cardtitle="item.name"></diet-pie>
                </li>
            </ul>
            <div class="clear"></div>
        </div>
        <div id="noneSpv" v-else v-show="show">
            <img src="./../../assets/img/noneSpv.png" style="margin: 45px auto;width: 260px;height: 280px;display: block;" />
            <span style="font-size: 18px;">暂无内容</span>
        </div>
    </div>
</template>
<script>
import dietPie from '../../components/utils/pie'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
export default {
  name: 'app',
  data () {
    return {
      data: {},
      categoryList: [],
      zeroWidth: {},
      badWidth: {},
      midWidth: {},
      goodWidth: {},
      amount: '',
      textColor: '#4C9BFA',
      legendShow: true,
      spvShow: true,
			show: false,
			did: '',
			flag: '0'
    }
  },
  methods: {
    optionFun (totalScore, avgScore) {
      let that = this
      var titleText = '\n' + avgScore
      if (avgScore === '' || avgScore === undefined) {
        that.textColor = '#ccc'
        titleText = '\n--'
        avgScore = 0
        $('#scoreShow').addClass('forbidden')
      }
      let myChart = this.$echarts.init(document.getElementById('spvPre'))
      that.option = {
        animation: false,
        series: {
          type: 'pie',
          radius: [60, 80],
          itemStyle: {
            normal: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              }
            }
          },
          data: [{
            value: avgScore,
            name: '得分'
          }, {
            value: totalScore - avgScore,
            name: '未得分'
          }]
        },
        title: {
          subtext: '上月平均得分',
          text: titleText,
          subtextStyle: {
            color: '#999',
            fontSize: 14
          },
          textStyle: {
            color: that.textColor,
            fontSize: 44
          },
          x: 'center'
        },
        color: ['#4C9BFA', '#eee']
      }
      myChart.setOption(that.option)
    },
    getGradeCard () {
      var self = this
      self.amount = self.data.zeroNum + self.data.badNum + self.data.midNum + self.data.goodNum
      var zeroWidth = (self.data.zeroNum / self.amount).toFixed(3) * 100 - 0.1
      var badWidth = (self.data.badNum / self.amount).toFixed(3) * 100 - 0.1
      var midWidth = (self.data.midNum / self.amount).toFixed(3) * 100 - 0.1
      var goodWidth = (self.data.goodNum / self.amount).toFixed(3) * 100 - 0.1
      self.zeroWidth = {width: zeroWidth + '%', display: zeroWidth > 0 ? 'inline-block' : 'none'}
      self.badWidth = {width: badWidth + '%', display: badWidth > 0 ? 'inline-block' : 'none'}
      self.midWidth = {width: midWidth + '%', display: midWidth > 0 ? 'inline-block' : 'none'}
      self.goodWidth = {width: goodWidth + '%', display: goodWidth > 0 ? 'inline-block' : 'none'}
    },
    getCategoryList (scorePolicyAreaId) {
      var self = this
      api.post(config.khsHost + 'spv/policy/hhs/getCategoryList.do', {'scorePolicyAreaId': scorePolicyAreaId}).then((data) => {
        if (data.success === true) {
          self.categoryList = data.body
          self.getSurveyStyle()
        }
      })
    },
    getSurveyStyle () {
      var width = document.body.clientWidth
      if (width < 1337) { // 三行
        $('#survey').find('li').addClass('liSty')
        $('#survey').find('li').removeClass('liStyMar')
        $.each($('#survey').find('li'), function (i) {
          if (i % 2 === 0) { // 奇数
            $(this).addClass('liStyMarR')
          }
        })
      } else {
        $('#survey').find('li').removeClass('liSty liStyMarR')
        $.each($('#survey').find('li'), function (i) {
          if ((i + 2) % 3 === 0) { // 奇数
            $(this).addClass('liStyMar')
          }
        })
      }
    },
    standardShow () {
    //   var menu = parent.$('#side-menu').find('a[moduleid =11081]')
    //   if (!menu.parent().hasClass('active')) {
    //     menu.click()
    //   }
        // parent.$('#side-menu').find('a[funcid=11308]').data('id')
        // console.log(parent.$('#side-menu').find('a[funcid=11308]')[0].data('id'))
        // 选项卡菜单已存在
		var flag = true
		var self = this
		var did = this.did
        parent.$('.J_menuTab').each(function () {
            if (($(this).data('id') === './supervisor.html#/supervisor') || ($(this).data('id').indexOf("#/supervisor")>0)) {
                // console.log($(this).data('id'))
			    flag = false
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active').siblings('.J_menuTab').removeClass('active')
                    // 显示tab对应的内容区
                    parent.$('.J_mainContent .J_iframe').each(function () {
                    if (($(this).data('id') === './supervisor.html#/supervisor') || ($(this).data('id').indexOf("#/supervisor")>0)) {
                        console.log($(this))
                        $(this).remove()
                        var str1 = '<iframe class="J_iframe" id="iframe"'
                        str1 += '" name="iframe93" width="100%" height="100%" src="./supervisor.html#/supervisor/?did='+did+'" frameborder="0" data-id="./supervisor.html#/supervisor" seamless></iframe>'
                        parent.$('.J_mainContent').find('iframe.J_iframe').hide().parents('.J_mainContent').append(str1)
                        // if (cId && cId !== $(this).attr('cId')) {
                        //   $(this).remove()
                        //   var strC = '<iframe class="J_iframe" id="iframe' + dataIndex + '" cId="' + cId + '"  name="iframe' + dataIndex + '" width="100%" height="100%" src="' + dataUrl + '" frameborder="0" data-id="' + dataUrl + '" seamless></iframe>'
                        //   $('.J_mainContent').find('iframe.J_iframe').hide().parents('.J_mainContent').append(strC)
                        // } else {
                        // $(this).show().siblings('.J_iframe').hide()
                        // }
                        return false
                    }
                    })
                }
				return false
			}
		})
        if(flag) {
            if(window.location.hostname.includes('localhost')) {
                console.log('???')
                var str = '<a href="javascript:" class="active J_menuTab" data-id="./supervisor.html#/supervisor">督导标准管理 <i class="fa fa-times-circle"></i></a>'
                parent.$('.J_menuTab').removeClass('active')
                var str1 = '<iframe class="J_iframe" id="iframe"'
                str1 += '" name="iframe93" width="100%" height="100%" src="./supervisor.html#/supervisor/?did='+this.did+'" frameborder="0" data-id="./supervisor.html#/supervisor" seamless></iframe>'
                parent.$('.J_mainContent').find('iframe.J_iframe').hide().parents('.J_mainContent').append(str1)
                parent.$('.J_menuTabs .page-tabs-content').append(str)
            } else {
                console.log('online')
                var str = '<a href="javascript:" class="active J_menuTab" data-id="'+ config.hhsHost +'module/supervisor.html#/supervisor">督导标准管理 <i class="fa fa-times-circle"></i></a>'
                parent.$('.J_menuTab').removeClass('active')
                var str1 = '<iframe class="J_iframe" id="iframe"'
                str1 += '" name="iframe93" width="100%" height="100%" src="./supervisor.html#/supervisor/?did='+this.did+'" frameborder="0" data-id="./supervisor.html#/supervisor" seamless></iframe>'
                parent.$('.J_mainContent').find('iframe.J_iframe').hide().parents('.J_mainContent').append(str1)
                parent.$('.J_menuTabs .page-tabs-content').append(str)
            }
        }
        var op = parent.$('#side-menu').find('a[funcid=11308]')[0].getAttribute("op")
        if(op) {
            var currentIframe = parent.$('.J_iframe')[parent.$('.J_iframe').length-1]
            // console.log(currentIframe.contentWindow)
            if(!currentIframe.contentWindow.paramFromParent) {
                currentIframe.contentWindow.paramFromParent = op
            }
        }
    },
    scoreDetails (need) { // 得分详情
      if ($('#scoreShow').hasClass('forbidden')) {
        return false
      }
      parent.$('#side-menu').find('a[funcid=11307]').attr('cId', need)
      var menu = parent.$('#side-menu').find('a[moduleid =11081]')
      if (!menu.parent().hasClass('active')) {
        menu.click()
      }
      parent.$('#side-menu').find('a[funcid=11307]').click()
    }
  },
  components: {
    dietPie
  },
  beforeCreate: function () {
    // 创建前状态
  },
  created: function () { // 创建完毕状态
    var self = this
    api.post(config.khsHost + '/support/forKhs/account/verifySupervisionAuth.do', {}).then((result) => {
      if (result.success === true && result.body.result === true) {
        api.post(config.khsHost + 'spv/policy/hhs/getLastMonthAvgScore.do', {}).then((data) => {
          if (data.success === true) {
            if (data.body) {
							self.did = data.body.scorePolicyAreaId
              self.spvShow = true
              self.data = data.body
              if (data.body.avgScore === '' || data.body.avgScore === undefined) {
                self.legendShow = false
              }
              self.optionFun(data.body.totalScore, data.body.avgScore)
              self.getGradeCard()
              self.getCategoryList(data.body.scorePolicyAreaId)
            }
            else{
                self.spvShow = false
            }
          }
        })
      } else {
        self.spvShow = false
      }
      self.show = true
    })
  },
  beforeMount: function () {

        // 挂载前状态

  },
  mounted: function () { // 挂载结束状态
  },
  beforeUpdate: function () {

        // 更新前状态

  },
  updated: function () {
    var self = this
    self.getSurveyStyle()
    window.onresize = function () {
      self.getSurveyStyle()
    }
    // 更新完成状态
  },
  beforeDestroy: function () {

        // 销毁前状态

  },
  destroyed: function () {

        // 销毁完成状态
  }
}
</script>
<style>
/*新版*/
.container-oftenUse {
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    color: #333;
    background: #fff;
    padding-left: 18px;
    margin-bottom: 20px;
    font-weight: bold;
}

.container-oftenUse span {
    margin-right: 10px;
    margin-left: 20px;
    cursor: pointer;
    color: #4c9bfa;
    font-weight: normal;
}

.scoreShow{
    margin-right: 20px;
    font-size: 12px;
    color: #4C9BFA;
    cursor: pointer;
}

.container-oftenUse span:hover,.scoreShow:hover{
    color: #70AFFB;
}

.container-lf {
    width: calc(60% - 15px);
    float: left;
    margin-right: 15px;
    box-sizing: border-box;
    background: #fff;
    min-height: 370px;
}

.backlog {
    width: 100%;
}

.backlog li {
    float: left;
    height: 66px;
    color: #555;
    padding: 10px 20px;
    box-sizing: border-box;
    width: 100%;
    cursor: pointer;
}

.backlog li:hover{
    background: #4C9BFA;
    color: #fff;
}

.backlog i {
    font-size: 12px;
    font-style: normal;
}

.backlog_title {
    height: 20px;
    line-height: 20px;
    margin-bottom: 5px;
}

.backlog_title span {
    font-size: 14px;
}
.container_title {
    width: 100%;
    height: 40px;
    line-height: 40px;
    color: #333;
    font-size: 12px;
    font-weight: bold;
    box-sizing: border-box;
    padding: 0 20px;
}

.container_title .standardShow {
    float: right;
    border: none;
    border-radius: 5px;
    background: rgb(99, 160, 239);
    color: rgb(255, 255, 255);
    padding: 0 10px;
    margin-top: 10px;
    cursor: pointer;
    height: 25px;
    line-height: 25px;
}

.container_supervisor {
    display: none;
    width: calc(40% - 15px);
    float: left;
    margin-left: 15px;
    height: 370px;
    background: #fff;
    box-sizing: border-box;
}
/*概况*/
.container_survey {
    width: 100%;
}

.container_survey li {
    float: left;
    height: 160px;
    margin-bottom: 20px;
    padding: 0 20px;
    background: #fff;
    cursor:pointer;
    width: calc(33.3% - 14px);
    min-width: 390px;
    box-sizing: border-box;
    font-size:14px;
}

.container_survey .liSty {
    width: calc(50% - 10px);
    margin: 0 0 20px !important;
}

.container_survey .liStyMarR{
    margin-right: 20px !important;
}

.container_survey .liStyMar{
    margin: 0 21px 20px 21px;
}

.container_survey div {
    height: 100%;
    text-align: center;
}

.container_survey span {
    width: 100%;
    color: #999;
    text-align: left;
    display: inline-block;
}

.container_survey .boxLf {
    width: 170px;
    float: left;
}

.container_survey .boxRg {
    width: 160px;
    float: right;
}

.font24 {
    font-size: 24px;
}

.font30 {
    font-style: normal;
    font-size: 30px;
    font-weight: bold;
}

.colorBFA {
    color: #4C9BFA;
}

.forbidden {
    color: #999 !important;
}

.hbg{
    color:#999
}

.hbg3{
    color:#30B0F6
}
.hbg2{
    color:#00C853
}
.hbg1{
    color:#F5A623
}
.hbg0{
    color:#FD6A7C
}

.gradeCard{
    float:left;
    padding-left: 2px;
}

.gradeCard span{
    text-align: center;
    width:100%;
    display:inline-block;
}
.cardBar{
    height:20px;
    margin-top: 5px;
    background:#4C9BFA;
}
.legend{
    margin: 20px auto;
    width: 80%;
}
.legend .cardBar{
    display: inline-block;
    height: 10px;
    width: 22px;
    border-radius: 3px;
    margin: 0 10px;
}
.legend i{
    font-size:12px;
    font-style:normal;
}
.zeroColor{
    opacity: 0.25;
}
.badColor{
    opacity: 0.5;
}
.midColor{
    opacity: 0.75;
}
#noneSpv{
    position: absolute;
    top: calc(50% - 200px);
    text-align: center;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/module/main/app.vue?3f89f87a